export const careersTranslation = {
  en: {
    careers: "Careers",
    jobs: "Jobs",
    applicants: "Applicants",
    exploreJobs: "Explore available job positions.",
    manageApplicants: "Manage job applicants.",
    addJob: "Add Job",
    editJob: "Edit Job",
    updateJob: "Update Job",
    addNewJob: "Add New Job",
    titleEN: "Title (EN)",
    titleAR: "Title (AR)",
    jobDescription : "Job Description",
    departmentEN: "Department (EN)",
    departmentAR: "Department (AR)",
    jobReference: "Job Reference",
    reportTo: "Report To",
    requirements: "Requirements",
    experience: "Experience",
    'Select Experience': "Select Experience",
    employmentType: "Employment Type",
    'Select Employment Type': "Select Employment Type",
    location: "Location",
    responsibilities: "Responsibilities",
    careerIntroduction: "Career Introduction",
    currentVacancies: "Current Vacancies",
    "Are you sure you want to delete applicant '{{name}}'?": "Are you sure you want to delete applicant '{{name}}'?",
    actionCannotBeUndone: "This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
    addApplicant: "Add Applicant",
    editApplicant: "Edit Applicant",
    updateApplicant: "Update Applicant",
    addNewApplicant: "Add New Applicant",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    selectJob: "Select Job",
    applicationDescription: "Application Description",
    cv: "CV",
    areYouSureDeleteApplicant: "Are you sure you want to delete applicant",
    search: "Search",
    createdAt: "Created at",
    actions: "Actions",
    home: "Home",
    landing: "Landing",
    rightArrow: "Right Arrow Icon",
    appliedAt : 'Applied at',
    "Choose date range for jobs": "Choose date range for jobs",
    "seoKeyWords": "SEO Keywords",
    "Choose date range for applicants":"Choose date range for applicants",
    "Are you sure you want to delete job '{{title}}'?": "Are you sure you want to delete job '{{title}}'?"
  },
  ar: {
    careers: "الوظائف",
    jobs: "الوظائف",
    applicants: "المتقدمون",
    exploreJobs: "استكشاف الوظائف المتاحة.",
    manageApplicants: "إدارة المتقدمين للوظائف.",
    addJob: "إضافة وظيفة",
    editJob: "تحرير الوظيفة",
    updateJob: "تحديث الوظيفة",
    addNewJob: "إضافة وظيفة جديدة",
    titleEN: "العنوان (EN)",
    titleAR: "العنوان (AR)",
    departmentEN: "القسم (EN)",
    departmentAR: "القسم (AR)",
    jobDescription: "وصف الوظيفة",
    jobReference: "مرجع الوظيفة",
    reportTo: "التقرير إلى",
    requirements: "المتطلبات",
    experience: "الخبرة",
    'Select Experience': "اختر الخبرة",
    employmentType: "نوع التوظيف",
    'Select Employment Type': "اختر نوع التوظيف",
    location: "الموقع",
    responsibilities: "المسؤوليات",
    careerIntroduction: "مقدمة عن الوظيفة",
    currentVacancies: "الوظائف الشاغرة الحالية",
    "Are you sure you want to delete applicant '{{name}}'?": "هل أنت متأكد أنك تريد حذف المتقدم '{{name}}'؟",
    actionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء.",
    cancel: "إلغاء",
    delete: "حذف",
    addApplicant: "إضافة متقدم",
    editApplicant: "تحرير المتقدم",
    updateApplicant: "تحديث المتقدم",
    addNewApplicant: "إضافة متقدم جديد",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    email: "البريد الإلكتروني",
    selectJob: "اختر وظيفة",
    applicationDescription: "وصف الطلب",
    cv: "السيرة الذاتية",
    areYouSureDeleteApplicant: "هل أنت متأكد أنك تريد حذف المتقدم ",
    search: "بحث",
    createdAt: "تاريخ الإنشاء",
    actions: "الإجراءات",
    home: "الصفحة الرئيسية",
    landing: "الصفحة الرئيسية",
    rightArrow: "أيقونة السهم الأيمن",
    appliedAt:'تقدمت لوظيفة في',
    "Choose date range for jobs": "اختر نطاق التاريخ للوظائف",
    "seoKeyWords": "كلمات مفتاحية لتحسين محركات البحث",
    "Choose date range for applicants":"اختر نطاق التاريخ للمتقدمين",
    "Are you sure you want to delete job '{{title}}'?": "هل أنت متأكد أنك تريد حذف الوظيفة '{{title}}'؟"
  },
};
